/**
 * Centralized content/copy strings for the Help & Support portal.
 * All user-facing static text is defined here for easy maintenance and localization.
 */

export const content = {
  errorBoundary: {
    header: "Something went wrong",
    body: "Please refresh the page again.",
    buttonLabel: "Refresh",
  },
  search: {
    heading: "How can we help?",
    placeholder: "Search or ask anything",
  },
};
